function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g id="error" transform="translate(35.417 34.891)">
        <g
          id="Group_43345"
          data-name="Group 43345"
          transform="translate(-35.417 -34.891)"
        >
          <g
            id="Group_43344"
            data-name="Group 43344"
            transform="translate(0 0)"
          >
            <circle
              id="Ellipse_11"
              data-name="Ellipse 11"
              cx="16.973"
              cy="16.973"
              r="16.973"
              transform="translate(0 24) rotate(-45)"
              fill="#149066"
            />
            <g
              id="Group_43343"
              data-name="Group 43343"
              transform="translate(21.251 12.106)"
            >
              <path
                id="Path_29649"
                data-name="Path 29649"
                d="M198.417,114.969a.836.836,0,0,1-.772-.771L195.7,101.069a2.6,2.6,0,0,1,2.233-3.169h.97a2.6,2.6,0,0,1,2.233,3.169L199.188,114.2A.835.835,0,0,1,198.417,114.969Z"
                transform="translate(-195.663 -97.9)"
                fill="#fff"
                fill-rule="evenodd"
              />
              <path
                id="Path_29650"
                data-name="Path 29650"
                d="M209.682,317.071a1.781,1.781,0,1,0-1.781,1.781A1.785,1.785,0,0,0,209.682,317.071Z"
                transform="translate(-205.147 -295.063)"
                fill="#fff"
                fill-rule="evenodd"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export { InfoIcon };
